import { fetchTokens, setApiToken } from './api'
import { setTokens } from './token_manager'

export async function initApp(token) {
  setApiToken(token)
  setTokens(await fetchTokens())
  console.log('finish init')
}
